export default __webpack_public_path__ + "assets/ad50de568967351682d3d7877e2f27aa.png";